import Flickity from 'flickity';

/**
 * Shop The Wall – Single
 * - Also used in Article Content Shop The Wall
 * @param {object} opts
 */
function shopTheWallSingle(opts) {
  const config = {
    dom: {
      carousel: 'js-shop-the-wall-single-carousel',
      hotspot: 'js-shop-the-wall-single-hotspot',
      wrapper: 'js-shop-the-wall-single',
    },
    cls: {
      active: 'is-active',
    },
  };
  const c = __.extend(config, opts);

  const flickityOpts = {
    contain: true,
    draggable: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
  };

  // global elements
  const $wrappers = document.body.querySelectorAll(`.${c.dom.wrapper}`);
  const flickityCarousels = [];
  let view;

  /**
   * Init
   */
  function init() {
    if (!$wrappers?.length) return;
    onWindowResize();
    __.windowResize(onWindowResize);
  }

  /**
   * On Window Resize
   */
  function onWindowResize() {
    // desktop
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view !== 'desktop') {
          view = 'desktop';
          rebuildFlickity();
        }
      },
    });

    // mobile
    __.mq({
      view: 'mobile',
      callback: () => {
        if (view !== 'mobile') {
          view = 'mobile';
          rebuildFlickity();
        }
      },
    });
  }

  /**
   * rebuild flickity
   */
  function rebuildFlickity() {
    [...$wrappers].forEach(($wrapper, index) => {
      const activeCarousel = flickityCarousels[index];
      if (activeCarousel) activeCarousel.destroy();
      const $carousel = $wrapper.querySelector(`.${c.dom.carousel}`);
      if (!$carousel) return;

      setTimeout(() => {
        const flickityCarousel = new Flickity($carousel, flickityOpts);

        // add active class to hotspot on change
        flickityCarousel.on('change', (changeIndex) => {
          const $activeHotspot = $wrapper.querySelector(`.${c.dom.hotspot}.${c.cls.active}`);
          const $hotspot = $wrapper.querySelector(`.${c.dom.hotspot}[data-index="${changeIndex}"]`);
          if ($activeHotspot) {
            __.removeClass($activeHotspot, c.cls.active);
          }
          if ($hotspot) {
            __.addClass($hotspot, c.cls.active);
          }
        });

        __.removeEvent({
          id: $wrapper,
          className: c.dom.hotspot,
          event: 'click',
          fn: (e) => {
            const hotspotIndex = e.target.dataset.index;
            flickityCarousel.select(hotspotIndex, true);
          },
        });

        __.addEvent({
          id: $wrapper,
          className: c.dom.hotspot,
          event: 'click',
          fn: (e) => {
            const hotspotIndex = e.target.dataset.index;
            flickityCarousel.select(hotspotIndex, true);
          },
        });

        if (activeCarousel) {
          flickityCarousels[index] = flickityCarousel;
        } else {
          flickityCarousels.push(flickityCarousel);
        }
      }, 500); // short timeout for Flickity cell sizing
    });
  }

  return init();
}

export default shopTheWallSingle;
